// extracted by mini-css-extract-plugin
export default {"header":"lqAF8","icons":"FocaM","icon":"nbT0S","businessUnitIcon":"W_BJK","logoutButton":"YVCDG"};